const progressConsts = {
  COMPLETED: 'COMPLETED',
  PREVIOUS: 'PREVIOUS',
  LOCKED: 'LOCKED',
  CURRENT: 'CURRENT',
  AVAILABLE: 'AVAILABLE',
};

export default progressConsts;
